import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form } from "antd";
import { PumpOptions } from "../../../../Data/data";

const AddPumpModal = ({ visible, onOk, onCancel, responeData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([
    "suctionPressure",
    "dischargePressure",
    "current",
  ]);

  const [customParams, setCustomParams] = useState([
    { name: "Flow Rate", unit: "m³/h" },
    { name: "Pressure Drop", unit: "bar" },
  ]);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (responeData) {
      form.setFieldsValue({
        title: responeData?.title || "",
        make: responeData?.pump_maker || "",
        model: responeData?.pump_model || "",
      });

      setSelectedParams(responeData?.selected_parameters || selectedParams);
      setCustomParams(
        Array.isArray(responeData?.other_parameters) ? responeData?.other_parameters : []
      );
    }
  }, [responeData, form]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  useEffect(() => {
    const hasEmptyFields = customParams.some(
      (param) =>
        !param.name.trim() || !param.unit.trim() || param.name.length > 50 || param.unit.length > 10
    );
    form
      .validateFields()
      .then(() => setIsFormValid(!hasEmptyFields))
      .catch(() => setIsFormValid(false));
  }, [customParams, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    const updated = [...customParams];
    updated.splice(index, 1);
    setCustomParams(updated);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
        };
        try {
          onOk(data);
        } catch (err) {
          console.error("Submit error:", err?.message || JSON.stringify(err));
        }
      })
      .catch((err) => {
        // Validation error fallback
        console.error("Validation failed:", err?.message || JSON.stringify(err));
      });
  };

  return (
    <Modal
      title="Add Pump"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="OK"
      okButtonProps={{ disabled: !isFormValid }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Pump Name"
          name="title"
          rules={[{ required: true, message: "Please enter a title" }]}
        >
          <Input placeholder="Pump Title" maxLength={50} />
        </Form.Item>

        <Form.Item
          label="Pump Maker"
          name="make"
          rules={[{ required: true, message: "Please enter a make" }]}
        >
          <Input placeholder="Pump Make" maxLength={50} />
        </Form.Item>
        <Form.Item
          label="Pump Model"
          name="model"
          rules={[{ required: true, message: "Please enter a model" }]}
        >
          <Input placeholder="Pump Model" maxLength={50} />
        </Form.Item>

        <Form.Item label="Select Regular Parameters to Log">
          <Checkbox.Group
            value={selectedParams}
            onChange={setSelectedParams}
            style={{ width: "100%" }}
          >
            <Row gutter={[8, 8]}>
              {PumpOptions.map((param) => (
                <Col span={12} key={param.value}>
                  <Checkbox value={param.value}>{param.label}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>

        <div style={{ marginTop: 16 }}>
          <b>Add Other Parameters</b>
          {customParams?.map((param, index) => (
            <Row gutter={8} key={index} style={{ marginTop: 8 }}>
              <Col span={10}>
                <Input
                  placeholder="Parameter"
                  value={param.name}
                  maxLength={50}
                  onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                />
              </Col>
              <Col span={10}>
                <Input
                  placeholder="Unit"
                  value={param.unit}
                  maxLength={10}
                  onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                />
              </Col>
              <Col span={4}>
                <Button danger onClick={() => handleDeleteParam(index)} block>
                  ×
                </Button>
              </Col>
            </Row>
          ))}
          <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12, marginLeft: 5 }}>
            + Add Parameter
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddPumpModal;
